<template lang="pug">
div
  b-modal#modal-scrollable.context(
    v-if="dialog.submit.sort === 'reject'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop)
    template(slot="modal-header")
      img(src="../../assets/admin_main_log.svg" style="height: 20px")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                :placeholder="`${this.newSubmitValue.start_time}`",
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled")
              b-form-timepicker(:placeholder="`${newSubmitValue.start_time_time}`" v-model="newSubmitValue.start_time_time")
              b-form-datepicker#app-period-after.mt-2(
                :placeholder="`${this.newSubmitValue.end_time}`",
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd")
              b-form-timepicker(:placeholder="`${newSubmitValue.end_time_time}`" v-model="newSubmitValue.end_time_time")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.newSubmitValue.approval_reason}`" v-model="newSubmitValue.approval_reason")
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(:placeholder="`${this.newSubmitValue.react_reason}`" disabled)
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        :variant="dialog.submit.color"
        :disabled="loadingSubmit"
        @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'ing'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.png`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                :placeholder="`${this.newSubmitValue.start_time}`",
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled")
              b-form-timepicker(:placeholder="`${this.newSubmitValue.start_time_time}`" v-model="newSubmitValue.start_time_time")
              b-form-datepicker#app-period-after.mt-2(
                :placeholder="`${this.newSubmitValue.end_time}`",
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd")
              b-form-timepicker(:placeholder="`${this.newSubmitValue.end_time_time}`" v-model="newSubmitValue.end_time_time")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.newSubmitValue.approval_reason}`" v-model="newSubmitValue.approval_reason")
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        :variant="dialog.submit.color"
        :disabled="loadingSubmit"
        @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'admin'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.png`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.adminSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.adminSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.adminSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(:placeholder="`${this.adminSubmitValue.start_time}`" disabled)
              b-form-timepicker(:placeholder="`${this.adminSubmitValue.start_time_time}`" disabled)
              b-form-datepicker#app-period-after.mt-2(:placeholder="`${this.adminSubmitValue.end_time}`" disabled)
              b-form-timepicker(:placeholder="`${this.adminSubmitValue.end_time_time}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.adminSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.adminSubmitValue.reason}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(
                v-model="adminSubmitValue.react_reason"
              )
    template(slot="modal-footer")
      div.btn-wrap
        b-button(
          size="sm"
          @click="close") {{$t('close')}}
        b-button.ml-2(
          size="sm"
          :variant="dialog.reject.color"
          @click="reject", v-t="dialog.reject.text")
        b-button.ml-2(
          size="sm"
          :variant="dialog.submit.color"
          :disabled="loadingSubmit"
          @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'admin_history'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header"
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.png`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.adminHistoryValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.adminHistoryValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.adminHistoryValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(:placeholder="`${this.adminHistoryValue.start_time}`" disabled)
              b-form-datepicker#app-period-after(:placeholder="`${this.adminHistoryValue.end_time}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.adminHistoryValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.adminHistoryValue.reason}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(:placeholder="`${this.adminHistoryValue.react_reason}`" v-model="adminHistoryValue.react_reason")
    template(slot="modal-footer")
      // approve_state : 1 (반려), 2 (승인), 4 (장치삭제)
      b-button(
        size="sm",
        @click="close") {{$t('close')}}
      b-button(
        v-if="dialog.item.approve_state === 1",
        size="sm"
        variant="primary"
        :disabled="loadingSubmit"
        @click="submit") {{$t('approval')}}
      b-button(
        v-else-if="dialog.item.approve_state === 2",
        size="sm"
        variant="danger"
        @click="reject") {{$t('reject-submit')}}
      b-button(
        v-else,
        size="sm"
        variant="primary"
        @click="reject") {{$t('deleted-device-edit')}}

  // @@@
  b-modal(
    v-else-if="dialog.submit.sort === 'new'",
    v-model="show",
    size="lg",
    modal-class="common-popup"
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        span.title {{$t('dialogs_page.remote_application_form')}}
        img.logo(src="@/assets/logo_popup.png")

    b-container(fluid)
      div.context
        b-form
          b-form-group(
            content-cols-sm
            :label="$t('request-agent')"
            label-for="device-name"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias} (${this.newSubmitValue.s_pri_ip})`" disabled)
          b-form-group(
            content-cols-sm
            :label="$t('ID')"
            label-for="id"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
          b-form-group(
            content-cols-sm
            :label="$t('applicant')"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
          b-form-group.request-date(
            content-cols-sm
            :label="$t('start_date')"
            label-for="app-period-start"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-input-group
              b-form-datepicker#app-period-start.mt-0.c-w-5(
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled",
                :placeholder="$t('start_time_ch')"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              )
              b-input-group-append.d-flex.align-items-center
                b-select.ml-2.h-100(v-model="newSubmitValue.start_time_hour" :options="hourOptions" size="sm")
                span.ml-1 {{$t('hour')}}
                b-select.ml-2.h-100(v-model="newSubmitValue.start_time_min" :options="minOptions" size="sm")
                span.ml-1 {{$t('minute')}}
          b-form-group.request-date.d-flex.align-items-center(
            content-cols-sm
            :label="$t('expire_date')"
            label-for="app-period-end"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-input-group
              b-form-datepicker#app-period-end.mt-0.c-w-5(
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd",
                :placeholder="$t('end_time_ch')"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              )
              b-input-group-append.d-flex.align-items-center
                b-select.ml-2.h-100(v-model="newSubmitValue.end_time_hour" :options="hourOptions" size="sm")
                span.ml-1 {{$t('hour')}}
                b-select.ml-2.h-100(v-model="newSubmitValue.end_time_min" :options="minOptions" size="sm")
                span.ml-1 {{$t('minute')}}
          b-form-group.request-date.d-flex.align-items-center(
            content-cols-sm
            :label="$t('approval_type')"
            label-for="approver-type"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-radio-group#approver-type(
              v-model="newSubmitValue.approver_type"
              :options="approverTypeList"
              :disabled="approverDisabled"
            )
          b-form-group(
            content-cols-sm
            :label="$t('approval_line')"
            label-for="approval"
            label-cols-sm="2"
            label-align-sm="left"
          )
            .d-flex.align-items-center
              b-form-input#approval.non-flex(
                :placeholder="`${this.newSubmitValue.approver_print}`"
                disabled
                style="width: 200px"
              )
              b-button.ml-2(
                size="sm"
                :disabled="approvalLineDisabled"
                @click="visibleDialogApprovalLine = true"
              ) {{$t('selection')}}
          b-form-group(
            content-cols-sm
            :label="$t('application_reason')"
            label-for="approval-kind"
            label-cols-sm="2"
            label-align-sm="left"
          ).align-items-start
            b-select#approval-kind.mb-2(
              size="sm"
              v-model="newSubmitValue.approval_kind",
              :options="approvalOptions",
              :placeholder="$t('approval_reason')"
              style="width: 200px"
            )
            template(v-if="newSubmitValue.approval_kind === 0")
              b-form-textarea#approval-reason(v-model="newSubmitValue.approval_reason" :disabled="approvalDisabled" @input.native="cutString(100, $event)")
              .count ({{ charCount }} / 100)
    template(slot="modal-footer")
      b-button(
        size="sm"
        variant="primary"
        :disabled="loadingSubmit"
        @click="submit", v-t="dialog.submit.text" pill)
      b-button(
        variant="secondary"
        size="sm"
        @click="close" pill) {{$t('cancel')}}

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'renew'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.png`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled")
              b-form-timepicker(v-model="newSubmitValue.start_time_time")
              b-form-datepicker#app-period-after.mt-2(
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd")
              b-form-timepicker(v-model="newSubmitValue.end_time_time")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.newSubmitValue.approval_reason}`" v-model="newSubmitValue.approval_reason")
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(
                :placeholder="`${this.newSubmitValue.react_reason}`"
                disabled
              )
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        :variant="dialog.submit.color"
        :disabled="loadingSubmit"
        @click="submit", v-t="dialog.submit.text")
  dialog-approval-line(
    :show.sync="visibleDialogApprovalLine"
    :userId="newSubmitValue.requester_id"
    :limit="newSubmitValue.approve_seq"
    @submit="submitApprovalLine"
  )
    //- :data="{ id: newSubmitValue.approver_mgrid, pk: newSubmitValue.approver_pk, name: newSubmitValue.approver_name }"

  confirm-dialogs(:show.sync="showDuplication" :option="{ size: 'md', title: $t('dialogs_page.duplicate_error') }")
    .warning
      icon.icon(name="exclamation-triangle" width="50" height="50")
      span ※ Warning ※
    .box
      .msg 현재 원격 신청하시려는 시작일시와#[br]#[em.text-danger 동일한 신청건이 이미 존재 합니다.]
      .msg {{$t('dialogs_page.change_start_date_and_retry')}}
    .bottom-btns
      b-btn(variant="secondary" size="sm" @click="showDuplication = false" pill) {{$t('submit')}}
</template>

<script>
import _ from "lodash"
import { user } from "@/api/access"
import { ApprovalsAPI, ApprovalAPI, ApprovalMacroAPI } from "../../api"
import moment from "moment"
import dialogApprovalLine from "./dialogApprovalLine"
import { store } from "@/api/store"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"

const defaultValues = {
  size: "lg",
  title: "",
  context: "",
  headerBgVariant: "light",
  headerTextVariant: "dark",
  bodyBgVariant: "light",
  bodyTextVariant: "dark",
  footerBgVariant: "light",
  footerTextVariant: "dark",
  align: "left",
  submit: {
    size: "sm",
    text: "submit",
    color: "primary",
    sort: "first",
  },
}
export default {
  name: "approval-request-dialog",
  components: {
    dialogApprovalLine,
    ConfirmDialogs,
  },
  computed: {
    hourOptions() {
      return _.range(0, 24).map(item => {
        const num = item < 10 ? "0" + item : item
        return { text: num, value: num }
      })
    },
    minOptions() {
      return _.range(0, 60).map(item => {
        const num = item < 10 ? "0" + item : item
        return { text: num, value: num }
      })
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.newSubmitValue.start_time = moment().format("YYYY-MM-DD")
        this.newSubmitValue.start_time_hour = moment().format("HH")
        this.newSubmitValue.start_time_min = moment().format("mm")

        this.newSubmitValue.end_time = moment().format("YYYY-MM-DD")
        this.newSubmitValue.end_time_hour = moment()
          .add(1, "hours")
          .format("HH")
        this.newSubmitValue.end_time_min = moment().format("mm")

        this.newSubmitValue.approval_kind = 0
        this.newSubmitValue.approver_type = 0
      }
    },
    "newSubmitValue.start_time"(val) {
      if (val > this.newSubmitValue.end_time) {
        this.newSubmitValue.end_time = val
      }
    },
    "newSubmitValue.approval_kind"(val) {
      this.newSubmitValue.approval_reason = ""
      if (val !== 0) {
        this.newSubmitValue.approval_reason = _.clone(_.find(this.approvalOptions, { value: val }).text)
      }
      this.approvalDisabled = val !== 0
      this.charCount = 0
    },
  },
  methods: {
    fetchReason() {
      const params = { request_type: 0 }
      ApprovalMacroAPI.get("", { params }).then(res => {
        res.data.objects.forEach(element => {
          this.approvalOptions.push({ text: element.title, value: element.pk })
        })
      })
    },
    cutString(num, event) {
      if (event.target.value.length > num) {
        event.target.value = event.target.value.slice(0, num)
        this.newSubmitValue.approval_reason = event.target.value
      }
      this.charCount = event.target.value.length
    },
    submitApprovalLine(form) {
      const id = []
      const pk = []
      const name = []
      const print = []
      for (const [index, item] of Object.values(form).entries()) {
        if (item.name) {
          id.push(item.id)
          pk.push(item.pk)
          name.push(item.name)
          print.push(item.print)

          // 결재 라인
          const check = _.find(this.approvalLineData, { seq: index + 1 })
          if (check) {
            check.mgrid = item.id
          } else {
            this.approvalLineData.push({
              userId: "",
              mgrid: item.id,
              apInfId: "",
              opinion: "",
              seq: index + 1,
              type: 0,
              type_pk: 1, // 이건?
            })
          }
        }
      }

      this.newSubmitValue.approver_print = print.join(",")
      this.newSubmitValue.approver_name = name.join(",")
      this.newSubmitValue.approver_pk = pk.join(",")
    },
    focusIn() {
      this.$refs.close.focus()
    },
    close() {
      this.show = false
    },
    dateDisabled(ymd, date) {
      const today = moment().format("YYYY-MM-DD")
      const tomorrow = moment()
        .add(1, "day")
        .format("YYYY-MM-DD")
      return ymd < today || ymd > tomorrow
    },
    dateDisabledEnd(ymd, date) {
      const startTime = this.newSubmitValue.start_time
      const endTime = moment(this.newSubmitValue.start_time)
        .add(1, "day")
        .format("YYYY-MM-DD")

      return ymd < startTime || ymd > endTime
    },
    submit() {
      this.loadingSubmit = true
      if (this.dialog.submit.sort === "admin") {
        this.show = false
        let params = {
          pk: this.adminSubmitValue.approvePK,
          is_accept: 1,
          react_reason: this.adminSubmitValue.react_reason,
        }
        this.cb("submit", params)
        this.adminSubmitValue.react_reason = ""
        this.loadingSubmit = false
      } else if (this.dialog.submit.sort === "admin_history") {
        this.show = false
        let params = {
          pk: this.adminHistoryValue.approvePK,
          is_accept: 1,
          react_reason: this.adminHistoryValue.react_reason,
        }
        this.cb("submit", params)
        this.loadingSubmit = false
      } else {
        let params = {
          // new : device_pk => device.js에서 추가
          device_pk: this.device_pk,
          approver_pk: this.newSubmitValue.approver_pk,
          approver_name: this.newSubmitValue.approver_name,
          post_approval: this.newSubmitValue.approver_type,
          start_time: moment(this.newSubmitValue.start_time + " " + this.newSubmitValue.start_time_hour + ":" + this.newSubmitValue.start_time_min).utc().format("YYYY-MM-DD HH:mm"),
          end_time: moment(this.newSubmitValue.end_time + " " + this.newSubmitValue.end_time_hour + ":" + this.newSubmitValue.end_time_min).utc().format("YYYY-MM-DD HH:mm"),
          approval_reason: this.newSubmitValue.approval_reason,
          manager_device_pk: store.get("manager_device_pk") || null,
        }
        if (params.start_time >= params.end_time || !this.newSubmitValue.start_time || !this.newSubmitValue.end_time) {
          this.AppState.$emit("show-message-dialog", { context: { path: "date_validate_error" } })
          this.loadingSubmit = false
          return
        } else if (!params.approver_pk) {
          this.AppState.$emit("show-message-dialog", { context: { path: this.$t('select_approval_line') } })
          this.loadingSubmit = false
          return
        } else if (!params.approval_reason) {
          this.AppState.$emit("show-message-dialog", { context: { path: "approvals_reason" } })
          this.loadingSubmit = false
          return
        } else {
          ApprovalsAPI.post("", params)
            .then(resp => {
              const { status, objects } = resp.data
              if (status === 200) {
                this.$awn.success(this.$t("approval-success"))
                this.newSubmitValue.approval_reason = ""
                this.show = false
                this.AppState.$emit("device-list-reload")
              } else {
                if (status === 405) {
                  this.showDuplication = true
                } else {
                  this.$awn.warning(objects.message)
                }
              }
              this.loadingSubmit = false
            })
            .catch(err => {
              this.AppState.$emit("show-message-dialog", { context: { path: err.response.data.message } })
              this.show = false
              this.loadingSubmit = false
            })
        }
      }
    },
    reject() {
      if (this.dialog.submit.sort === "admin") {
        this.show = false
        let params = {
          pk: this.adminSubmitValue.approvePK,
          is_accept: 0,
          react_reason: this.adminSubmitValue.react_reason,
        }
        this.cb("reject", params)
        this.adminSubmitValue.react_reason = ""
      } else if (this.dialog.submit.sort === "admin_history") {
        this.show = false
        let params = {
          pk: this.adminHistoryValue.approvePK,
          is_accept: 0,
          react_reason: this.adminHistoryValue.react_reason,
        }
        this.cb("reject", params)
      }
    },
    async getApproval(user) {
      //승인자정보GET
      const resp = await ApprovalsAPI.get("approver")

      this.approverDisabled = false
      this.newSubmitValue.approve_seq = resp.data.objects[0].approve_seq

      if (user.flag_use_approval === 0) {
        this.newSubmitValue.approver_pk = String(user.pk)
        this.newSubmitValue.approver_name = user.name
        this.newSubmitValue.approver_mgrid = user.mgrid
        this.newSubmitValue.approver_print = `${user.name} (${user.mgrid})`
        this.newSubmitValue.approver_type = 2
        this.approverDisabled = true
        this.approvalLineDisabled = true
      } else {
        _.find(this.approverTypeList, { value: 2 }).disabled = true
      }

      _.find(this.approverTypeList, { value: 1 }).disabled = !user.post_approval

      return resp.data.objects
    },
  },
  created() {
    this.dialog = defaultValues
    this.AppState.$on("show-approval-request-dialog", (data, cb) => {
      this.fetchReason()
      this.device_pk = data.device_pk
      this.dialog = _.assignIn({}, defaultValues, data)
      if (data.value) this.value = data.value
      if (typeof cb === "function") this.cb = cb
      this.show = true
      if (data.submit.sort === "admin") {
        this.adminSubmitValue.approveInfo = data.approveInfo
        this.adminSubmitValue.approvePK = data.approvePK
        for (let i = 0; i < this.adminSubmitValue.approveInfo.length; i++) {
          if (this.adminSubmitValue.approveInfo[i].pk == this.adminSubmitValue.approvePK) {
            this.adminSubmitValue.device_alias = this.adminSubmitValue.approveInfo[i].device_alias
            this.adminSubmitValue.requester_id = this.adminSubmitValue.approveInfo[i].requester_id
            this.adminSubmitValue.requester_name = this.adminSubmitValue.approveInfo[i].requester_name
            this.adminSubmitValue.approver_name = this.adminSubmitValue.approveInfo[i].approver_name
            this.adminSubmitValue.start_time = moment(this.adminSubmitValue.approveInfo[i].start_time).format("YYYY-MM-DD")
            this.adminSubmitValue.start_time_time = moment(this.adminSubmitValue.approveInfo[i].start_time).format("HH:mm:ss")
            this.adminSubmitValue.end_time = moment(this.adminSubmitValue.approveInfo[i].end_time).format("YYYY-MM-DD")
            this.adminSubmitValue.end_time_time = moment(this.adminSubmitValue.approveInfo[i].end_time).format("HH:mm:ss")
            this.adminSubmitValue.reason = this.adminSubmitValue.approveInfo[i].reason
          }
        }
      } else if (data.submit.sort === "new") {
        this.newSubmitValue.device_alias = data.alias
        this.newSubmitValue.s_pri_ip = data.s_pri_ip

        const getUser = user()
        this.newSubmitValue.requester_id = getUser.mgrid
        this.newSubmitValue.requester_name = getUser.name

        this.approvalLineData = []

        this.newSubmitValue.start_time = ""
        this.newSubmitValue.start_time_time = ""
        this.newSubmitValue.end_time = ""
        this.newSubmitValue.end_time_time = ""
        this.getApproval(getUser)
      } else if (data.submit.sort === "admin_history") {
        this.adminHistoryValue = data.item
        this.adminHistoryValue.start_time = moment(data.item.start_time).format("YYYY-MM-DD HH:mm:ss")
        this.adminHistoryValue.end_time = moment(data.item.end_time).format("YYYY-MM-DD HH:mm:ss")
        this.adminHistoryValue.approvePK = data.item.pk
        this.adminHistoryValue.react_reason = data.item.react_reason
      } else {
        this.newSubmitValue.requestInfo = data.requestInfo
        this.newSubmitValue.approvePK = data.approvePK
        for (let i = 0; i < this.newSubmitValue.requestInfo.length; i++) {
          if (this.newSubmitValue.requestInfo[i].pk == this.newSubmitValue.approvePK) {
            this.newSubmitValue.device_alias = this.newSubmitValue.requestInfo[i].device_alias
            this.newSubmitValue.requester_id = this.newSubmitValue.requestInfo[i].requester_id
            this.newSubmitValue.requester_name = this.newSubmitValue.requestInfo[i].requester_name
            this.newSubmitValue.approver_name = this.newSubmitValue.requestInfo[i].approver_name
            this.newSubmitValue.start_time = moment(this.newSubmitValue.requestInfo[i].start_time).format("YYYY-MM-DD")
            this.newSubmitValue.start_time_hour = moment(this.newSubmitValue.requestInfo[i].start_time).format("HH")
            this.newSubmitValue.start_time_min = moment(this.newSubmitValue.requestInfo[i].start_time).format("mm")
            this.newSubmitValue.end_time = moment(this.newSubmitValue.requestInfo[i].end_time).format("YYYY-MM-DD")
            this.newSubmitValue.end_time_hour = moment(this.newSubmitValue.requestInfo[i].end_time).format("HH")
            this.newSubmitValue.end_time_min = moment(this.newSubmitValue.requestInfo[i].end_time).format("mm")
            this.newSubmitValue.react_reason = this.newSubmitValue.requestInfo[i].react_reason
            this.newSubmitValue.device_pk = this.newSubmitValue.requestInfo[i].device_fk
            this.newSubmitValue.approval_reason = this.newSubmitValue.requestInfo[i].reason
            this.newSubmitValue.approver_pk = this.newSubmitValue.requestInfo[i].approver_fk
          }
        }
      }
    })
  },
  data() {
    return {
      show: false,
      showDuplication: false,
      loadingSubmit: false,
      device_pk: null,
      dialog: {},
      value: "",
      charCount: 0,
      maxChar: 0,
      approvalOptions: [
        { text: this.$t('manual_input'), value: 0 },
        // { text: "재택근무", value: 2 },
        // { text: "장애대응", value: 3 },
        // { text: "파견", value: 4 },
        // { text: "유지보수", value: 5 },
      ],
      approvalDisabled: false,
      approverDisabled: false,
      approvalLineDisabled: false,
      newSubmitValue: {
        requestInfo: [],
        approvePK: "",
        device_alias: "",
        requester_id: "",
        requester_name: "",
        start_time: "",
        end_time: "",
        start_time_hour: "00",
        start_time_min: "00",
        end_time_hour: "00",
        end_time_min: "00",
        approver_type: 0,
        approver_name: "",
        approver_print: "",
        approver_name_pure: "",
        approval_kind: 0,
        approval_reason: "",
        react_reason: "",
        approver_pk: "",
        device_pk: "",
      },
      adminSubmitValue: {
        approveInfo: [],
        approvePK: "",
        device_alias: "",
        requester_id: "",
        requester_name: "",
        start_time: "",
        end_time: "",
        start_time_time: "",
        end_time_time: "",
        approver_name: "",
        reason: "",
        react_reason: "",
      },
      adminHistoryValue: {
        start_time_time: "",
        end_time_time: "",
        approvePK: "",
        react_reason: "",
      },
      cb() {},

      visibleDialogApprovalLine: false,
      approvalLineData: [
        {
          userId: "",
          mgrid: "",
          apInfId: "",
          opinion: "",
          seq: 0,
          type: 0,
          type_pk: 1, // 이건?
        },
      ],

      approverTypeList: [
        { text: this.$t('pre_approval'), value: 0, disabled: false },
        { text: this.$t('post_approval'), value: 1, disabled: false },
        { text: this.$t('exception'), value: 2, disabled: false },
      ],
    }
  },
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
<style lang="scss" scoped>
.btn-secondary {
  color: black !important;
  background-color: #ffffff;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.container-fluid {
  padding: 1rem;
  margin: 0;
}

.form-group {
  display: flex;
  align-items: center;
}

.form-control {
  background-color: #ffffff !important;
  height: 1.9rem;
  color: #8f8f8f;
  font-size: 13px;
}

.request-date {
  align-items: start;
}

.b-form-timepicker,
.b-form-datepicker {
  margin-top: 0.5rem;
}

.dropdown {
  display: flex;
  align-items: center;
}

::v-deep .modal-footer {
  border: none;
  padding: 0 1rem 1rem 1rem;
}

textarea {
  height: auto !important;
}
.count {
  font-size: 12px;
}

.b-form-btn-label-control::v-deep {
  &.form-control {
    height: auto;
  }
}
</style>
